module.exports = __webpack_public_path__ + "static/logo-compliance-fe9081cb8a80c1e540ba2c299f219adf.png";